import React, { FC, useEffect, useState } from "react";
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Table,
  Tag,
  Typography,
} from "antd";
import type { ColumnGroupType, ColumnType, ColumnsType } from "antd/es/table";
import {
  GetDataOrderListData,
  GetDataOrderListItems,
  GetOrderDetailData,
} from "services/interface";
import { formatDate, formatDateWithTime } from "utils/dateFormat";
import {
  calculateTimeDifference,
  getPaymentName,
  getPaymentStatusName,
} from "utils/convertData";
import ModalOderDetail from "../OrderTabsCard/ModalOrderDetail";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setLoading } from "store/slices/loadingSlice";
import { useGetOrderDetail } from "hooks/useOrders";
import { setDataCancelLimit, setDataCancelOffset } from "store/slices/orderSlice";
import { useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import ModalRefundOrder from "../OrderTabsCard/ModalRefundOrder";
import { numberFormat } from "utils/nuberFormat";
import ModalRefundPayment from "../OrderTabsCard/ModalRefundPayment";
import moment from "moment";
import { orderManualConfirm } from "config";

interface OrderTableListProps {
  data?: GetDataOrderListData;
  IsHiddenPersonInfo?: boolean;
  refetchData: () => void;
  childrenBank: React.ReactNode[];
  factory_id: string;
}

const OrderTableList: FC<OrderTableListProps> = ({
  data,
  IsHiddenPersonInfo,
  refetchData,
  childrenBank,
  factory_id
}) => {
  const navigate = useNavigate();
  const tabsKey = 5;
  const dispatch = useAppDispatch();
  const offset = useAppSelector((state) => state.order.dataCancel.offset);
  const limit = useAppSelector((state) => state.order.dataCancel.limit);
  const [showDetail, setShowDetail] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [modalData, setModalData] = useState<GetOrderDetailData>();
  const { mutate } = useGetOrderDetail();
  const [currentPage, setCurrentPage] = useState(1);

  const [currentTime, setCurrentTime] = useState(moment());

    const contactData = useAppSelector((state) => state.auth.contact);
    const use_platform_transport = contactData?.use_platform_transport;
  

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 60000);

    dispatch(setDataCancelOffset(0));
    dispatch(setDataCancelLimit(10));

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setCurrentPage(Math.floor(offset / limit) + 1);
  }, [offset, limit]);


  const columns: ColumnsType<GetDataOrderListItems> = [
    {
      title: "Order No.",
      dataIndex: "order_code",
      key: "order_id",
      render: (_text, record) => {
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={async () => {
              dispatch(setLoading(true));

              mutate(
                {
                  key_type: "order_id",
                  group_by: "factory",
                  items: [record.order_id],
                  factory_id: factory_id,
                },
                {
                  onSuccess: async (data) => {
                    setModalData({ ...data.data[0], payment_status: record.payment_status, payment_amount: record.payment_amount, final_price: restPrice });

                    await new Promise((resolve) => setTimeout(resolve, 200));

                    dispatch(setLoading(false));

                    setShowDetail(true);
                  },
                  onError: (error) => {
                    console.log(error);
                    dispatch(setLoading(false));
                  },
                }
              );
            }}
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      // title: 'เวลา',
      // dataIndex: 'order_date',
      render: (_text, record) => {
        return <Typography >
          {_text ? (
            <>
              {calculateTimeDifference(record.order_date, currentTime)}
            </>
          ) : '-'}
        </Typography>
      },
    },
    {
      title: "วันที่สั่งซื้อ",
      dataIndex: "order_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDateWithTime(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "วันที่ต้องส่งสินค้า",
      dataIndex: "due_date",
      render: (_text) => {
        return (
          <Typography>
            {_text ? formatDate(_text) : '-'}
          </Typography>
        );
      },
    },
    {
      title: "ชื่อผู้ซื้อ",
      dataIndex: "ref_name",
      key: "ref_name",
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
              maxWidth: "180px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "inline-block",
            }}
            type="secondary"
            onClick={() => {
              if (record.ref_type === "agent") {
                navigate(`/manage-agent/update-agent/${record.ref_id}?section=order&t=${tabsKey}`);
              } else if (record.ref_type === "retail") {
                navigate(`/manage-agent/update-retail/${record.ref_id}?section=order&t=${tabsKey}`);
              }
            }}
          >
            {_text ?? ''}
            <Typography.Text className="text-order-agent-name">
              {" "}{record && record.ref_alias ? `(${record.ref_alias})` : ''}
            </Typography.Text>
          </Typography.Link>
        );
      },
    },
   /* {
      title: "ประเภทลูกค้า",
      dataIndex: "ref_type",
      key: "ref_type",
      render: (_text) => {
        return <Typography>{_text ?? ''}</Typography>;
      },
    },*/
    {
      title: "เบอร์โทรศัพท์",
      dataIndex: "ref_telephone",
      key: "ref_telephone",
      render: (_text) => {
        return <Typography>{_text}</Typography>;
      },
    },
    /*{
      title: "ประเภทการขนส่ง",
      width: "100px",
      dataIndex: "transport_name",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },*/
    {
      title: "ช่องทางการสั่งซื้อ",
      key: "datasource_text",
      width: "100px",
      dataIndex: "datasource_text",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },
    {
      title: "ประเภทการชำระเงิน",
      width: "100px",
      dataIndex: "payment_type",
      key: "payment_type",
      render: (_text) => {
        return (
          <Typography style={_text === "COD" ? { color: "#ff4d4f" } : undefined}>
            {getPaymentName(_text, "en")}
          </Typography>
        );
      },
    },
    {
      title: "เครดิตที่ใช้ (COD)",
      dataIndex: "cod_credit_reserved_amount",
      key: "cod_credit_reserved_amount",
      render: (_text, record) => {
        if (record.payment_type !== "COD" || record.cod_credit_reserved_amount == null) {
          return <Typography>-</Typography>;
        }
        const isInsufficient = record.cod_credit_has_debt === true;
        return (
          <Typography style={isInsufficient ? { color: "#ff4d4f" } : undefined}>
            {numberFormat(record.cod_credit_reserved_amount)}
            {isInsufficient && (
              <Tag color="red" style={{ marginLeft: 6 }}>
                เครดิตไม่พอ
              </Tag>
            )}
          </Typography>
        );
      },
    },
    // {
    //   title: "สถานะการชำระเงิน",
    //   dataIndex: "payment_status",
    //   render: (_text, record) => {
    //     const statusName = getPaymentStatusName(_text);
    //     let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
    //     return (
    //       <Typography>
    //         {restPrice > 0 ?
    //           <Tag color="magenta">ชำระเงินเกิน</Tag>
    //         :
    //           <Tag color={statusName?.color}>{statusName?.th}</Tag>
    //         }
    //       </Typography>
    //     );
    //   },
    // },
    {
      title: "จำนวนเงินที่ต้องโอนคืน",
      dataIndex: "factory_refund",
      align: "right",
      render: (_text, record) => {
        return (
          <>
            {record.factory_refund > 0 ?
              <Typography.Text style={{ fontWeight: 500, color: 'red' }}>
                {numberFormat(record.factory_refund)}
              </Typography.Text>
              :
              <> - </>
            }
          </>
        );
      },
    },
    // {
    //   title: "ยอดเงินค้างชำระ",
    //   render: (_text, record) => {
    //     let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
    //     return (
    //       <>
    //       {restPrice > 0 && (
    //         <Typography>
    //           {numberFormat(restPrice)}
    //         </Typography>
    //       )}
    //       {restPrice === 0 && (
    //         <Typography>
    //           -
    //         </Typography>
    //       )}
    //       {restPrice < 0 && (
    //         <Typography style={{ color: 'red' }}>
    //           {numberFormat(restPrice)}
    //         </Typography>
    //       )}
    //     </>
    //     );
    //   },
    // },
    {
      title: "จังหวัดปลายทาง",
      dataIndex: "province_name",
      render: (_text) => {
        return (
          <Typography>
            {_text}
          </Typography>
        );
      },
    },
    {
      title: "เหตุผลการขอยกเลิก",
      width: "100px",
      ellipsis: {
        showTitle: true,
      },
      dataIndex: "reason_cancel",
      render: (_text) => {
        return (
          <Typography.Text
            ellipsis={
              _text
                ? {
                  // expandable: false,
                  // suffix: "...",
                  tooltip: _text,
                }
                : false
            }
          >
            {_text || ''}
          </Typography.Text>
        );
      },
    },
    {
      title: "เครื่องมือ",
      align: "center",
      width: 100,
      fixed: 'right',
      render: (_text, record) => {
        let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
        return (
          <>
            {(record.factory_refund > 0 && orderManualConfirm.includes(record.payment_type))
              // || (record.factory_refund > 0  && !orderManualConfirm.includes(record.payment_type) && record.payment_status === 'confirm')
              && (
                <Button
                  type="default"
                  size="small"
                  style={{
                    fontSize: '10px'
                  }}
                  onClick={() => {
                    dispatch(setLoading(true));

                    mutate(
                      {
                        key_type: "order_id",
                        group_by: "factory",
                        items: [record.order_id],
                        factory_id: factory_id,
                      },
                      {
                        onSuccess: async (data) => {
                          setModalData({ ...data.data[0], payment_status: record.payment_status, payment_amount: record.payment_amount, final_price: restPrice, factory_refund: record.factory_refund });

                          await new Promise((resolve) => setTimeout(resolve, 200));

                          dispatch(setLoading(false));

                          setShowRefund(true);
                        },
                        onError: (error) => {
                          console.log(error);
                          dispatch(setLoading(false));
                        },
                      }
                    );
                  }}
                >
                  คืนเงิน
                </Button>
              )}
          </>
        )
      }
    },
    // {
    //   title: "คืนเงิน",
    //   align: "center",
    //   width: 100,
    //   fixed: 'right',
    //   render: (_text, record) => {
    //     let restPrice = -((record.total_order_price + record.transport_price) - (record.discount_amount + record.payment_amount));
    //     return (
    //     <>
    //     {restPrice > 0 && (
    //     <Button
    //       type="default"
    //       size="small"
    //       style={{
    //         fontSize:'10px'
    //       }}
    //       onClick={()=> {
    //         dispatch(setLoading(true));

    //         mutate(
    //           {
    //             key_type: "order_id",
    //             group_by: "factory",
    //             items: [record.order_id],
    //           },
    //           {
    //             onSuccess: async (data) => {
    //               setModalData({ ...data.data[0], payment_status: record.payment_status, final_price: restPrice });

    //               await new Promise((resolve) => setTimeout(resolve, 200));

    //               dispatch(setLoading(false));

    //               setShowRefund(true);
    //             },
    //             onError: (error) => {
    //               console.log(error);
    //               dispatch(setLoading(false));
    //             },
    //           }
    //         );
    //       }}
    //     >
    //       คืนเงิน
    //     </Button>
    //     )}
    //   </>
    //     )
    //   }
    // }
  ];

  let filtersColumns: (
    | ColumnGroupType<GetDataOrderListItems>
    | ColumnType<GetDataOrderListItems>
  )[] = columns;
  if (IsHiddenPersonInfo) {
    filtersColumns = columns.filter(
      (column) => column.key !== "ref_name" && column.key !== "ref_telephone"
    );
  }

    if (!use_platform_transport) {
    filtersColumns = filtersColumns.filter(
      (column) => column.key !== "status_label"
    );
  }

  if (use_platform_transport) {
    filtersColumns = filtersColumns.filter(
    //  (column) => column.key !== "datasource_text" && column.key !== "rest_price" && column.key !== "refund" && column.key !== "payment_type"
      (column) => column.key !== "datasource_text" && column.key !== "rest_price" && column.key !== "refund" 
    );
  }

  return (
    <div>
      <Table
        rowKey="order_id"
        size="small"
        columns={filtersColumns}
        dataSource={data?.order_data}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: parseInt(data?.total_record as string),
          onChange: (page, pageSize) => {
            dispatch(setDataCancelOffset(pageSize! * (page! - 1)));
            dispatch(setDataCancelLimit(pageSize!));
          },
        }}
        scroll={{ x: true }}
      />
      <ModalOderDetail
        open={showDetail}
        onClose={() => {
          setShowDetail(false);

        }}
        item={modalData as GetOrderDetailData}
        childrenBank={childrenBank}
        refetchData={refetchData}
        statusPage="cancel"
      />
      {/* <ModalRefundOrder
        open={showRefund}
        onClose={() => {
          setShowRefund(false);
        }}
        item={modalData as GetOrderDetailData}
        refetchData={refetchData}
      /> */}
      <ModalRefundPayment
        open={showRefund}
        refund_process={"cancel_order"}
        onClose={() => {
          setShowRefund(false);
        }}
        item={modalData as GetOrderDetailData}
        refetchData={refetchData}
      />
    </div>
  );
};

export default OrderTableList;